module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "viz-wrapper"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(0)]) : (_vm.renderData && _vm.renderData.series && _vm.renderData.series.length == 0) ? _c('div', {
    staticClass: "text-center vertical-center h-100 no-data-banner"
  }, [_c('span', [_vm._v("No data")])]) : [(_vm.renderData && _vm.renderData.type == 'chart') ? _c('ls-chart', {
    attrs: {
      "target-css-classes": "chart",
      "height": _vm.height,
      "width": _vm.width,
      "target-id": _vm.chartId,
      "bc-data": _vm.renderData.series,
      "bc-layout": _vm.renderData.layout
    }
  }) : (_vm.renderData && _vm.renderData.type == 'banner') ? _c('ls-metric-banner', {
    attrs: {
      "series": _vm.renderData.series
    }
  }) : (_vm.renderData && _vm.renderData.type == 'table') ? _c('ls-table', {
    attrs: {
      "table-data": _vm.renderData.series,
      "table-layout": _vm.renderData.layout
    }
  }) : (_vm.renderData && _vm.renderData.type == 'raw') ? void 0 : (!_vm.isLoading) ? _c('div', {
    staticClass: "text-error text-center vertical-center h-100"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-3x fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "fa-1x"
  }, [_vm._v("Sorry! Something went wrong. Please, try again later.")])]) : _vm._e()]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center vertical-center h-100"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-3x fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e026fe1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/VizWidget.vue
// module id = 640
// module chunks = 0